module.exports = __webpack_public_path__ + "img/index-logo2.a1e686a4.png";